import axios from "axios";

export const APP_NAME = "M3 Quotes";
export const HOMEPAGE_URL = "https://markiiisys.com"
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL
axios.defaults.baseURL = BASE_API_URL;
